import { render, staticRenderFns } from "./TierProductRemove.vue?vue&type=template&id=5c21a469&scoped=true&"
import script from "./TierProductRemove.vue?vue&type=script&lang=js&"
export * from "./TierProductRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21a469",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c21a469')) {
      api.createRecord('5c21a469', component.options)
    } else {
      api.reload('5c21a469', component.options)
    }
    module.hot.accept("./TierProductRemove.vue?vue&type=template&id=5c21a469&scoped=true&", function () {
      api.rerender('5c21a469', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Tier/TierProductRemove.vue"
export default component.exports